import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import List from '@/components/List';
import CaseDetail from '@/components/CaseDetail';
import Login from '@/components/Login';
import Register from '@/components/Register';
import ForgetPass from '@/components/ForgetPass';
import UserPolicy from '@/components/UserPolicy';
import Collect from '@/components/Collect';
import News from '@/components/News';
import ShopDeatil from '@/components/ShopDetail';
import NewsDetail from '@/components/NewsDetail';
import Pay from '@/components/Pay';
import OrderList from '@/components/OrderList';
import PaySuccess from '@/components/PaySuccess';
import WeixinPay from '@/components/WeixinPay';
import AboutUs from '@/components/AboutUs';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '',
      name: 'Index',
      component: Index,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/forgetpass',
      name: 'ForgetPass',
      component: ForgetPass,
    },
    {
      path: '/user/policy',
      name: 'UserPolicy',
      component: UserPolicy,
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs,
    },
    {
      path: '/list',
      name: 'List',
      component: List,
    },
    {
      path: '/collect',
      name: 'Collect',
      component: Collect,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/caseDetail/:id',
      name: 'CaseDetail',
      component: CaseDetail,
    },
    {
      path: '/shopDetail/:id',
      name: 'ShopDeatil',
      component: ShopDeatil,
    },
    {
      path: '/newsDetail/:id',
      name: 'NewsDetail',
      component: NewsDetail,
    },
    {
      path: '/pay/:id',
      name: 'Pay',
      component: Pay,
    },
    {
      path: '/order/list/',
      name: 'OrderList',
      component: OrderList,
    },
    {
      path: '/success_pay/:id',
      name: 'PaySuccess',
      component: PaySuccess,
    },
    {
      path: '/weixin_pay/',
      name: 'WeixinPay',
      component: WeixinPay,
    },
  ],
});


router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js